<template>
<section class="section">
  <div class="container">
    <div class="columns">
      <div class="column">
        <div class="columns is-desktop">
          <div class="column is-2">
            <div class="field">
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="perPage" @change="onPerPageChange">
                    <option value="10">10 per page</option>
                    <option value="15">15 per page</option>
                    <option value="25">25 per page</option>
                    <option value="50">50 per page</option>
                    <option value="100">100 per page</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <div class="control">
                <input type="text" class="input" placeholder="Search" v-model="searchText" @input="changeSearchText">
              </div>
            </div>
          </div>
          <div class="column is-2">
            <button class="button is-info is-fullwidth" @click="onFilter">Search</button>
          </div>
          <!-- <div class="column is-2">
            <div class="field">
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="UserBacklink" @change="onPerPageChange">
                    <option value="">All</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div> -->
          <div class="column is-2">
            <button @click="exportPage" class="button is-link is-fullwidth">Download Report</button>
          </div>
        </div>
        
        <b-table :key="detailViewKey"
          :data="records"
          :loading="isLoading"
          paginated
          backend-pagination
          :total="totalRows"
          :per-page="perPage"
          :current-page="currentPage"
          @page-change="onPageChange"
          :default-sort-direction="defaultSortOrder"
          :default-sort="[sortField, sortOrder]"
          @sort="onSort"
          >
          <template slot-scope="props">
              <b-table-column field="userId" label="Id" sortable numeric>{{ props.row.userId }}</b-table-column>
              <b-table-column field="userEmail" label="Email" sortable>{{ props.row.userEmail }}</b-table-column>
              <b-table-column field="popUser" label="Backlinks Users" sortable>{{ props.row.popUser }}</b-table-column>
              <b-table-column field="comment" label="Comment" sortable>{{ props.row.comment }}</b-table-column>
             <b-table-column field="dismiss" label="Dismiss" sortable>{{ props.row.dismiss }}</b-table-column>
              <b-table-column field="submittedAt" label="Submitted Date" sortable numeric>{{ props.row.submittedAt }}</b-table-column>
          </template>
        </b-table>
      </div>
    </div>

  </div>
  <page-setting-modal ref="pageSettingModal" :disableDeletePage="true" :isAdminSetupTheGuard="true" />
</section>
</template>

<script>
import { mixin } from '@/components/mixin'
import PageSettingModal from "@/components/PageSettingModal.vue";
import { mixin as exportmixin } from '@/components/export_mixin'
import { toLocalDateString } from '@/utils'

export default {
  components: { PageSettingModal },
  mixins: [mixin, exportmixin],
  data () {
    return {
      records: [],
      totalRows: 0,
      isLoading: false,
      sortField: 'createdAt',
      sortOrder: 'desc',
      defaultSortOrder: 'asc',
      currentPage: 1,
      perPage: 15,
      isSimple: false,
      isRounded: false,
      searchText: '',
      proxies: [],
      UserBacklink: '',

      detailViewKey: 0,
    }
  },
  computed: {
    currentUser () {
      if (this.$store.state.user) {
        return this.$store.state.user.id
      }
      return {}
    }
  },
  methods: {
    test() {
      this.$nextTick(() => this.loadData())
    },
    openPageSettingModal(row) {
      this.$refs.pageSettingModal.show(row.page, this.loadData, row.email, row.pageRun);
    },

    showDetailsForPageRun (pageRun) {
      this.$store.commit('showLoading');
      this.$store.commit('setCurrentPageRun', pageRun)
      this.$store.commit('hideLoading');
    },
    getBaseUrl (fullUrl) {
      let pathArray = fullUrl.split( '/')
      let protocol = pathArray[0]
      let host = pathArray[2]
      let url = protocol + '//' + host
      return url
    },
    lsaPhrases (pageRun) {
      if(pageRun['lsaPhrases'] == undefined || !Array.isArray(pageRun['lsaPhrases']))  {
        return []
      } else  {
        return pageRun.lsaPhrases
          .map(item => { // round weight as 2 digits
            let newItem = Object.assign({}, item)
            newItem.weight = Math.round(newItem.weight * 100) / 100
            return newItem;
          })
      }
    },
    exportPage () {
    this.$store.commit('showLoading')
    this.$store.dispatch('loadFeedbackDownload')
        .then(() => {
        this.$store.commit('hideLoading')
        })
        .catch(error => {
        console.error('Error exporting data:', error)
        this.$store.commit('hideLoading')
        this.$store.commit('showError', 'Failed to download feedback report.')
        })
    },

    toLocalDateString (dateStr) {
      return toLocalDateString(dateStr)
    },
    onUserBacklinkChange () {
      this.currentPage = 1
      this.loadData()
    },

    onPerPageChange () {
      this.$nextTick(() => this.loadData())
    },
    onPageChange (page) {
      this.currentPage = page
      this.loadData()
    },
    onSort (field, order) {
      this.sortField = field
      this.sortOrder = order
      this.loadData()
    },
    onFilter () {
      this.$nextTick(() => {
        this.loadData()
      })
    },

    loadData () {
        this.isLoading = true
        this.$store.commit('showLoading')

        const params = [
            `page=${this.currentPage}`,
            `perPage=${this.perPage}`,
            `email=${this.searchText}`,
            this.UserBacklink !== '' ? `is_pop_useful=${this.UserBacklink}` : null
        ].join('&')

    this.$store.dispatch('loadFeedbackBacklinksForAdmin', { params })
        .then(({ data }) => {
        const { feedback, pagination } = data
        this.records = feedback.map(item => ({
            userId: item.id,
            userEmail: item.user_email,
            popUser: item.is_pop_useful ? 'Yes' : 'No',
            comment: item.comment,
            dismiss : item.dismiss ? 'Yes' : 'No',
            submittedAt: this.toLocalDateString(item.submitted_at)
        }))
        this.totalRows = pagination.total

        this.isLoading = false
        this.$store.commit('hideLoading')
        this.detailViewKey = parseInt(Math.random() * 1000, 10)
        })
        .catch(error => {
        console.error('Error loading data:', error)
        this.isLoading = false
        this.$store.commit('hideLoading')
        })
    },

    changeSearchText () {
      console.log(this.searchText);
    }
  },
  beforeMount () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.table-mobile-sort {
  display: none;
}
</style>